// Description: Endpoint to refresh token
// Updated: 21/08/2025
// Author: Simon Franklin

import axios from 'axios';

export async function Refresh(refreshToken) {

  const data = new URLSearchParams({
    grant_type: 'refresh_token',
    client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
    refresh_token: refreshToken.refresh_token.toString(),
  });

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_COGNITO_URL}/oauth2/token`,
      data,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );

    return response.data;
  } catch (error) {
    
    if (error.response) {
      throw new Error(error.response.data.error_description || 'Erro ao renovar token.');
    } else {
      throw new Error('Erro inesperado ao renovar token. Tente novamente mais tarde.');
    }
  }
}